import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { background, secondary } = theme.palette;
  const { sm, md } = theme.breakpoints;
  const { spacing } = theme;

  const componentWrapper = css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: ${spacing(5, 4)};
    background: ${background.gray3};
    display: flex;
    flex-direction: column;
    align-items: center;

    & h3 {
      text-align: center;
    }

    @media (max-width: ${`${md}px`}) {
      padding: ${spacing(4, 1)};
    }
  `;

  const stepsWrapper = css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    gap: ${spacing(4)};
    margin-top: ${spacing(3)};

    @media (max-width: ${`${sm}px`}) {
      grid-template-columns: 1fr;
      gap: ${spacing(3)};
    }
  `;

  const stepStyle = css`
    & > img {
      width: 100%;
      height: auto;
    }

    & p {
      margin-top: ${spacing(1)};

      @media (max-width: ${`${md}px`}) {
        font-size: 16px;
        line-height: 21px;
      }
    }
  `;

  const subText = css`
    max-width: 600px;
    margin: ${spacing(1, 'auto', '0')};
    text-align: center;

    @media (max-width: ${`${sm}px`}) {
      text-align: left;
    }
  `;

  return {
    componentWrapper,
    stepsWrapper,
    stepStyle,
    subText,
  };
};

export default useStyle;
